import React, { useState, useEffect } from 'react';
import ProductBasicInfo from '../../../components/ProductManagement/ProductBasicInfo';
import ProductImagesCreate from '../../../components/ProductManagement/ProductImagesCreate';
import ProductDescription from '../../../components/ProductManagement/ProductDescription';
import ProductPreview from '../../../components/ProductManagement/ProductPreview';
import { productApi, categoryApi } from '../../../services/productApi';
import Heading2 from "../../../components/Basic/Heading2";
import ToggleField from "../../../components/ProductManagement/ToggleField";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";
import {toast} from "react-hot-toast";

const initialProductData = {
  name: '',
  brand: '',
  category: null,
  description: '',
  unit_of_measure: 'count',
  status: '',
  attributes: {},
  custom_attributes: [],
  is_packable: true,
  is_fragile: false,
  is_flammable: false,
  is_liquid: false,
  is_corrosive: false,
  width: '',
  length: '',
  height: '',
  weight: '',
  delivery_by_supplier: true,
  delivery_by_customer: true,
  delivery_by_carrier: true,
  images: [],
  featured_image: null,
};

const ProductCreate = () => {
  const [categories, setCategories] = useState([]);
  const [imageItems, setImageItems] = useState([]);
  const [productData, setProductData] = useState(initialProductData);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [savingAction, setSavingAction] = useState(null);
  const [categoryAttributes, setCategoryAttributes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadCategories = async () => {
      setLoadingCategories(true);
      try {
        const res = await categoryApi.getLeaves();
        setCategories(res.data || []);
      } catch (err) {
        console.error('خطا در بارگذاری دسته‌ها:', err);
      } finally {
        setLoadingCategories(false);
      }
    };

    loadCategories();
  }, []);

  const prepareProductData = () => {
    const data = {
      name: productData.name || '',
      brand: productData.brand || '',
      category: productData.category,
      description: productData.description || '',
      unit_of_measure: productData.unit_of_measure || 'count',
      status: productData.status,
      attributes: productData.attributes || {},
      custom_attributes: productData.custom_attributes || [],
      featured_image: productData.featured_image,
      is_packable: productData.is_packable,
      is_fragile: productData.is_fragile,
      is_flammable: productData.is_flammable,
      is_liquid: productData.is_liquid,
      is_corrosive: productData.is_corrosive,
      delivery_by_supplier: productData.delivery_by_supplier,
      delivery_by_customer: productData.delivery_by_customer,
      delivery_by_carrier: productData.delivery_by_carrier,
    };

    if (
      productData.width !== '' &&
      productData.width !== null &&
      productData.width !== undefined
    ) {
      const n = Number(productData.width);
      if (!Number.isNaN(n)) data.width = n;
    }

    if (
      productData.length !== '' &&
      productData.length !== null &&
      productData.length !== undefined
    ) {
      const n = Number(productData.length);
      if (!Number.isNaN(n)) data.length = n;
    }

    if (
      productData.height !== '' &&
      productData.height !== null &&
      productData.height !== undefined
    ) {
      const n = Number(productData.height);
      if (!Number.isNaN(n)) data.height = n;
    }

    if (
      productData.weight !== '' &&
      productData.weight !== null &&
      productData.weight !== undefined
    ) {
      const n = Number(productData.weight);
      if (!Number.isNaN(n)) data.weight = n;
    }

    return data;
  };

  const getStatusLabel = (status) => {
    if (status === 'draft') return 'ذخیره پیش‌نویس';
    if (status === 'pending') return 'ارسال محصول';
    return 'ذخیره محصول';
  };

  const resetProductForm = () => {
    setProductData(initialProductData);
    setImageItems([]);
    setCategoryAttributes([]);
  };

  const handleCreateProduct = async (status, options = {}) => {
    const { redirectAfterSuccess = false } = options;
    if (status === 'pending') {
      if (!productData.name.trim()) {
        toast.error('نام کالا باید وارد شود.')
        return;
      }
      if (!productData.brand.trim()) {
        toast.error('برند کالا باید وارد شود.')
        return;
      }
      if (!productData.category) {
        toast.error('دسته کالا باید انتخاب شود.')
        return;
      }

      if (imageItems.length === 0) {
        toast.error('حداقل یک عکس باید انتخاب شود.')
        return;
      }
      const hasFeaturedImage = imageItems.some((item) => item.is_featured === true);

      if (!hasFeaturedImage) {
        toast.error('عکس شاخص باید انتخاب شود.');
        return;
      }
    }


    setSavingAction(status);
    try {
      const submitData = prepareProductData();
      submitData.status = status;

      console.log(`${getStatusLabel(status)}:`, submitData);

      const response = await productApi.create(submitData);
      console.log('پاسخ سرور:', response.data);

      if (imageItems.length > 0 && response.data?.id) {
        console.log("imageItems",imageItems)
        console.log('در حال آپلود تصاویر...');
        await productApi.uploadImages(response.data.id, imageItems);
      }
      if(status === 'draft'){
        toast.success("کالا به‌عنوان پیش‌نویس ذخیره شد.")
      } else if (status === 'pending'){
        toast.success("کالا برای تایید ارسال شد.")
      }

      if (redirectAfterSuccess) {
        resetProductForm();
        navigate(-1);
      }
    } catch (err) {
      // const errorMessage = err.response?.data?.error?.message || "خطایی رخ داده است.";
      //   toast.error(errorMessage);

      console.error(`خطا در ${getStatusLabel(status)}:`, err);
      alert(
        `خطا در ${getStatusLabel(status)}: ` +
          JSON.stringify(err.message?.data || err.message)
      );
    } finally {
      setSavingAction(null);
    }
  };

  const handleToggleChange = (fieldKey, value) => {
    setProductData((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
  };

  const getCategoryName = (categoryId) => {
    if (!categoryId) return 'بدون دسته‌بندی';
    const found = categories.find((c) => c.id === categoryId);
    return found ? found.name : `دسته‌بندی ${categoryId}`;
  };

  const getPreviewData = () => {
    return {
      ...productData,
      category: productData.category
        ? {
            id: productData.category,
            name: getCategoryName(productData.category),
          }
        : null,
      width: productData.width || 0,
      length: productData.length || 0,
      height: productData.height || 0,
      weight: productData.weight || 0,
      images: imageItems || [],
      attributes: productData.attributes || {},
      custom_attributes: productData.custom_attributes || [],
      description: productData.description || '',
    };
  };

  const handleCancel = () => {
    if (window.confirm('آیا از انصراف مطمئن هستید؟ تغییرات ذخیره نخواهند شد.')) {
      navigate('/supplier-panel/supplier-product-management/');
    }
  };

  const PreviewModal = ({ open, onClose }) => {
    if (!open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center p-4 bg-black bg-opacity-50 overflow-auto">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-8xl my-4">
          <div className="flex justify-between items-center p-6 border-b">
            <h3 className="text-xl font-bold text-gray-800">پیش‌نمایش محصول</h3>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>
          </div>

          <div className="p-6 max-h-[80vh] overflow-y-auto">
            <ProductPreview
              productData={getPreviewData()}
              categoryAttributes={categoryAttributes}
            />
          </div>

          <div className="flex justify-end p-6 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="p-6">
      <section className="bg-white rounded-lg shadow-sm p-6 mb-6 border">
        <Heading2 text={'اطلاعات کلی کالا'} />
        <ProductBasicInfo
          productData={productData}
          setProductData={setProductData}
          categories={categories}
          loading={loadingCategories}
          categoryAttributes={categoryAttributes}
          setCategoryAttributes={setCategoryAttributes}
        />
      </section>

      <section className="bg-white rounded-lg shadow-sm p-6 mb-6 border">
        <Heading2 text={'روش‌های ارسال'} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ToggleField
            title={'ارسال توسط تأمین کننده'}
            checked={productData.delivery_by_supplier}
            fieldKey="delivery_by_supplier"
            onChange={handleToggleChange}
          />
          <ToggleField
            title={'تحویل توسط مشتری'}
            checked={productData.delivery_by_customer}
            fieldKey="delivery_by_customer"
            onChange={handleToggleChange}
          />
          <ToggleField
            title={'ارسال توسط شرکت حمل'}
            checked={productData.delivery_by_carrier}
            fieldKey="delivery_by_carrier"
            onChange={handleToggleChange}
          />
        </div>
      </section>

      <section className="bg-white rounded-lg shadow-sm p-6 mb-6 border">
        <ProductImagesCreate
          productData={productData}
          setProductData={setProductData}
          imageItems={imageItems}
          setImageItems={setImageItems}
        />
      </section>

      <section className="bg-white rounded-lg shadow-sm p-6 mb-6 border">
        <ProductDescription
          productData={productData}
          setProductData={setProductData}
        />
      </section>

      <div className="flex flex-wrap gap-3">
        <Button
          variant="primary"
          children={
            savingAction === 'pending' ? 'در حال ارسال...' : 'ارسال برای تأیید'
          }
          onClick={() =>
            handleCreateProduct('pending', { redirectAfterSuccess: true })
          }
          disabled={savingAction !== null}
        />

        <Button
          variant="secondary"
          children={
            savingAction === 'draft' ? 'در حال ذخیره...' : 'ذخیره پیش‌نویس'
          }
          onClick={() => handleCreateProduct('draft', { redirectAfterSuccess: true })}
          disabled={savingAction !== null}
        />

        <button
          type="button"
          onClick={() => setShowPreview(true)}
          disabled={savingAction !== null}
          className="px-6 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-50"
        >
          پیش‌نمایش
        </button>

        <button
          type="button"
          onClick={handleCancel}
          disabled={savingAction !== null}
          className="px-6 py-2 rounded-md bg-red-500 text-white hover:bg-red-600 transition-colors disabled:opacity-50"
        >
          انصراف
        </button>
      </div>

      <PreviewModal
        open={showPreview}
        onClose={() => setShowPreview(false)}
      />
    </div>
  );
};

export default ProductCreate;
